export default "__VITE_ASSET__UTFdhj2K__"